<template>
    <div class="header-wrapper" v-bind:class="{'align_logo_to_center': (userData === null || userData.currentUser === undefined)}">
        <div class="logo">
            <template v-if="this.$md.mobile() !== null">
                <i class="user-info"></i>
            </template>
            <img src="/static/img/logo.svg">
            <template v-if="this.$md.mobile() !== null">
                <i class="settings-icon"></i>
            </template>
        </div>
        <div class="navigation-menu" v-if="(userData !== null && userData.currentUser !== undefined)">
            <div v-bind:class="{active: activeTabName == 'AdgroupReport' || activeTabName == null}">
                <router-link :to="{ path: '/adgroupReport' }">Reports</router-link>
            </div>
            <div  v-bind:class="{active: activeTabName == 'tools'}">
                <router-link :to="{ path: 'tools' }">Tools</router-link>
            </div>
            <div v-bind:class="{active: activeTabName == 'management'}">
                <router-link :to="{ path: 'management' }">Management</router-link>
            </div>
            <div v-bind:class="{active: activeTabName == 'notes'}">
                <router-link :to="{ path: 'notes' }">Notes</router-link>
            </div>
        </div>
        <div class="userInfo">
            <span v-if="userData !== null && userData.currentUser !== undefined">
                Welcome, <b>{{userData.currentUser.firstName + ' ' + userData.currentUser.lastName}}</b>
                <i class="toggle-down-icon"></i>
                <i class="settings-icon"></i>
            </span>
        </div>
    </div>
</template>

<script>

  import Vue from 'vue';
  import VueLocalStorage from 'vue-ls';

  Vue.use(VueLocalStorage, {
    namespace: 'clickscontrol_'
  });

  export default {
    name: "cc-header",
    data() {
      return {
        activeTabName: null,
        userData: this.$store.getters.getUserData
      }
    },
    created() {
      let route = this.$route;

      if (route !== null) {
        this.activeTabName = route.name;
      }
    },
    mounted(){
      let userData = this.$store.getters.getUserData;

      if (userData === null || userData.currentUser == undefined)
      {
        let localStorageUserData = this.$ls.get('userData');

        this.$store.dispatch('setUserData', localStorageUserData);
      }
    }
  }
</script>

<style lang="scss" scoped>

    .header-wrapper {
        display: grid;
        grid-area: header;
        grid-template-columns: auto 70% 15%;
        grid-template-rows: 1fr;
        background: $header-background-color;
        height: 60px;
        width: 100%;
    }

    .logo {
        grid-column: 1;
        grid-row: 1;
        text-align: left;
        margin: auto 0 auto 25px;

        img {
            grid-column: 2;
            width: 100%;
        }
    }

    .align_logo_to_center {
        grid-template-columns: auto;
        justify-content: center;
    }

    .navigation-menu {
        display: grid;
        grid-template-columns: repeat(4, 135px);
        margin-left: 25px;
        grid-column: 2;
        grid-row: 1;

        div {
            display: flex;
            margin: 10px 0 0 10px;
            background-color: #1469a0;
            border: 1px solid #1469a0;
            cursor: pointer;


            & > a {
                font-size: 14px;
                font-weight: bold;
                color: #89BCDD;
                text-decoration: none;
                align-self: center;
                width: 100%;
            }

            &.active {
                background-color: #f0f0f0;
                border: 1px solid #f0f0f0;

                & > a {
                    color: #666666;
                }
            }
        }
    }

    .userInfo {
        grid-column: 3;
        grid-row: 1;
        margin: auto 0;
        margin-right: 15px;
        text-align: right;

        & > span {
            color: #fff;

            & > i {
                vertical-align: middle;
            }

            i.toggle-down-icon {
                display: inline-block;
                width: 0.65em;
                height: 0.65em;
                margin-right: 5px;
                margin-left: 5px;
                background-image: url('/static/img/icon-user-info-toggle-bottom.svg');
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
            }

            i.settings-icon {
                display: inline-block;
                width: 1.4em;
                height: 1.4em;
                margin-right: 5px;
                margin-left: 5px;
                background-image: url('/static/img/icon-user-info-settings.svg');
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
            }
        }
    }

    @include mobile-only{

        .userInfo { display: none; }

        .header-wrapper{
            height: auto;
            width: 100%;
            display: block;
            grid-template-columns: auto;
            text-align: center;

            & > .logo {
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                margin: 15px 10px 15px 10px;

                & > img {
                    width: 50%;
                    align-self: center;
                }
            }
        }

        .navigation-menu {
            margin-left: 0;
            grid-template-columns: repeat(4, 1fr);

            div {
                height: 40px;
                padding-left: 10px;
                padding-right: 10px;
                background-color: #1469a0;
                margin: 10px 0 0 10px;
                border: 1px solid #1469a0;
                cursor: pointer;

                & > a {
                    font-size: 0.9rem;
                    font-weight: 700;
                    color: #89bddd;
                }

                &.active {
                    background-color: #ffffff;
                    color: #666666;
                    border: 1px solid #ffffff;
                }
            }

            div:last-child {
                margin-right: 10px;
            }
        }

        i.user-info {
            display: inline-block;
            width: 1.5em;
            height: 1.5em;
            margin-right: 5px;
            margin-left: 5px;
            background-image: url('/static/img/icon-user-info-mobile.svg');
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
        }

        i.settings-icon {
            display: inline-block;
            width: 1.5em;
            height: 1.5em;
            margin-right: 5px;
            margin-left: 5px;
            background-image: url('/static/img/icon-user-info-settings.svg');
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/common/CCHeader.vue